export function newsletterFooter() {
    const form = document.getElementById('footer-newsletter-form'),
        header = document.getElementById("footer-newsletter-header"),
        message = document.getElementById('footer-newsletter-form-message'),
        button = form.querySelector('button'),
        captchaInput = document.querySelector("#footer-newsletter-form .g-recaptcha-response");

    if (!form) {
        return
    }

    form.addEventListener("submit", function(e) {
        e.preventDefault()
        form.email.setAttribute('aria-invalid', 'false')
        const email = validateEmail()

        if (email && validateAgreements()) {
            button.setAttribute("disabled", "disabled")
            const httpRequest = new XMLHttpRequest()
            const httpUrl = form.getAttribute("action")
            let formData = new FormData(form)
            const errorMessage =
                "Wystąpił problem. Spróbuj ponownie później."
            formData.append("isAjax", "1")
            httpRequest.addEventListener("load", function() {
                message.style.display = "block"
                button.removeAttribute("disabled")
                if (httpRequest.readyState === 4) {
                    const data = JSON.parse(httpRequest.response)

                    if (data.status == 'error') {
                      const input = form.email
                      removeAdvices(input)
                      addAdvices(input, data.message)
                      if (captchaInput != undefined) {
                        captchaInput.value = ''
                      }

                      return
                    }

                    message.innerText = data.message
                    if (data.status === "success") {
                        header.innerText = data.message
                        header
                            .parentElement
                            .parentElement
                            .classList
                            .add("footer__newsletter--success")
                        form.style.display = "none"
                    } else if (!data.message) {
                        message.innerText = errorMessage
                    }
                } else {
                    message.innerText = errorMessage
                }
            })

            httpRequest.open("POST", httpUrl)
            httpRequest.send(formData)
        }

        form.email.focus()
        form.email.setAttribute('aria-invalid', 'true')

        return false
    })

    function validateEmail() {
        const emailRex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/,
            input = form.email
        removeAdvices(input)
        if (!emailRex.test(input.value)) {
            addAdvices(input, input.getAttribute('data-advice'))
            return false
        } else {
            removeAdvices(input)
            return true
        }
    }

    function validateAgreements() {
        const inputs = form.elements['agreements[]']
        let valid = true
        if (inputs instanceof RadioNodeList) {
            inputs.forEach(function (input) {
                if (!validateAgreement(input)) {
                    valid = false
                }
            })
        } else {
            if (!validateAgreement(inputs)) {
                valid = false
            }
        }
        return valid
    }

    function validateAgreement(input) {
        removeAdvices(input)
        if (!input.checked && input.required) {
            addAdvices(input, input.getAttribute('data-advice'))
            return false
        }
        return true
    }

    function addAdvices(input, advice) {
        let adviceElement = document.createElement('div')
        adviceElement.setAttribute('role', 'alert')
        adviceElement.classList.add('validation-advice')
        adviceElement.innerText = advice
        adviceElement.id = 'advice-required-entry-newsletter-footer'
        input.classList.add('validation-failed')
        if (input.parentElement.matches('.form-group._email')) {
            input.parentElement.parentElement.insertBefore(
                adviceElement,
                input.parentElement.nextSibling
            )
        } else {
            input.parentElement.appendChild(adviceElement)
        }
    }

    function removeAdvices(input) {
        const adviceElement = input.parentElement.parentElement.querySelectorAll(
            '.validation-advice'
        )
        input.classList.remove('validation-failed')
        Array.from(adviceElement).forEach(function (el) {
            el.remove()
        })
    }
}
